import { render, staticRenderFns } from "./PartsPrevious.vue?vue&type=template&id=779653b8&scoped=true"
import script from "./PartsPrevious.vue?vue&type=script&lang=js"
export * from "./PartsPrevious.vue?vue&type=script&lang=js"
import style0 from "./PartsPrevious.vue?vue&type=style&index=0&id=779653b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779653b8",
  null
  
)

export default component.exports